export enum ToothPlacement {
	BUCCAL_LEFT = 'BUCCAL_LEFT',
	BUCCAL_RIGHT = 'BUCCAL_RIGHT',
	LINGUAL_LEFT = 'LINGUAL_LEFT',
	LINGUAL_RIGHT = 'LINGUAL_RIGHT',
	PALATAL_LEFT = 'PALATAL_LEFT',
	PALATAL_RIGHT = 'PALATAL_RIGHT',
}
